export const news6 = () => {
    return (
        <p>
            Миссия конгресса - организовать среду для передачи опыта и знаний между всеми участниками конференции. Расширение знаний и обмен опытом позволяют избежать ошибок во врачебной практике и способствуют повышению качества онкопомощи населению.
        </p> 
    );
}

export default news6;